export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;
